import React, { PureComponent } from "react";
import "./list.css";

export default class List extends PureComponent {
    static get propTypes() {
        return {
            children: React.PropTypes.oneOfType([React.PropTypes.array,React.PropTypes.object])
        };
    }

    render() {
        if (this.props.children === undefined || this.props.children === null) {
            return null;
        } else {
            return <div className="appointment-list"> {this.props.children} </div>;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/list.js
 **/